import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ConsentBanner } from "@/components/ConsentBanner";
import { PageMeta } from "@/components/PageMeta";
import { AnalyticsRouteListener } from "@/components/AnalyticsRouteListener";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Formations from "@/pages/Formations";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import Donate from "@/pages/Donate";
import Impact from "@/pages/Impact";
import Conditions from "@/pages/Conditions";
import Confidentialite from "@/pages/Confidentialite";
import Partner from "@/pages/Partner";
import Benevole from "@/pages/Benevole";
import Bourses from "@/pages/Bourses";
import PlanAction from "@/pages/PlanAction";
import Desabonnement from "@/pages/Desabonnement";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import { ADMIN_BASE, ADMIN_LOGIN, ADMIN_MDP } from "@/lib/adminPath";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PageMeta />
        <ScrollToTop />
        <AnalyticsRouteListener />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/formations" element={<Formations />} />
            <Route path="/bourses" element={<Bourses />} />
            <Route path="/plan-action" element={<PlanAction />} />
            <Route path="/blogue" element={<Blog />} />
            <Route path="/blogue/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/don" element={<Donate />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/conditions-utilisation" element={<Conditions />} />
            <Route path="/politique-confidentialite" element={<Confidentialite />} />
            <Route path="/devenir-partenaire" element={<Partner />} />
            <Route path="/devenir-benevole" element={<Benevole />} />
            <Route path="/desabonnement" element={<Desabonnement />} />
            <Route path={ADMIN_LOGIN} element={<AdminLogin />} />
            <Route path={ADMIN_MDP} element={<AdminChangePassword />} />
            <Route path={ADMIN_BASE} element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <ConsentBanner />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
